import React from 'react'

import { ProgressBar, ProgessStep } from '@welcom/esg-react-components'

export const Statusbar = ({ currentStep }) => {
   const labels = [
      'Pupil',
      'Guardians',
      'Siblings',
      'Fritids',
      'Review & Submit'
   ]
   const Steps = labels.map((label, index) => {
      let status = 'upcoming'

      if (currentStep === index) {
         status = 'current'
      } else if (index < currentStep) {
         status = 'done'
      }

      return <ProgessStep label={label} progress={status} key={index} />
   })

   return <ProgressBar>{Steps}</ProgressBar>
}
